/**
 * sun-header-init.js — Null-safe override de `HeaderComponent#drawerToggleEvent`
 *
 * Le bundle Broadcast (`assets/theme.js`) définit `<header-component>` dont le
 * `connectedCallback` appelle `drawerToggleEvent()` qui fait :
 *
 *   this.querySelector('[data-drawer-toggle]').addEventListener('click', ...)
 *
 * …sans null-check. Notre `sections/sun-header.liquid` (PR #28) a remplacé le
 * hamburger Broadcast par `<sun-menu-overlay>` et a laissé tomber l'attribut
 * `data-drawer-toggle`. Résultat : `querySelector` renvoie `null`, le
 * `.addEventListener` lève un TypeError qui interrompt `connectedCallback`
 * AVANT `cartToggleEvent()` → aucun listener n'est posé sur `[data-cart-toggle]`
 * → le clic sur Panier suit le `<a href="{{ routes.cart_url }}">` natif au lieu
 * d'ouvrir le cart drawer.
 *
 * Pourquoi `customElements.define` est intercepté (et pas `whenDefined`
 * comme dans `sun-cart-drawer-ajax.js`) : `drawerToggleEvent` tourne pendant
 * `connectedCallback`, synchrone avec l'upgrade du custom element. Or
 * `whenDefined` résout en microtask APRÈS l'upgrade, donc un patch via
 * `whenDefined` arriverait trop tard. On wrap `customElements.define` pour
 * patcher `HeaderComponent.prototype` juste avant que le `define` natif ne
 * déclenche l'upgrade.
 *
 * Contrainte : doit être chargé AVANT `theme.js` dans le document (cf.
 * `snippets/head.liquid`).
 *
 * Patch idempotent (drapeau `sunDrawerTogglePatched`).
 */
(function () {
  if (!window.customElements || typeof window.customElements.define !== 'function') return;

  const originalDefine = window.customElements.define.bind(window.customElements);

  window.customElements.define = function (name, constructor, options) {
    if (name === 'header-component' && constructor && constructor.prototype && !constructor.prototype.sunDrawerTogglePatched) {
      constructor.prototype.sunDrawerTogglePatched = true;

      const originalDrawerToggleEvent = constructor.prototype.drawerToggleEvent;

      constructor.prototype.drawerToggleEvent = function () {
        if (!this.querySelector('[data-drawer-toggle]')) return;

        originalDrawerToggleEvent.call(this);
      };
    }

    return originalDefine(name, constructor, options);
  };
})();
